// skipcq: JS-W1028
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import {
  REVIEW_REACTION_EMOJI_ORDER,
  readReviewReactionEngageMetrics,
} from '../../utils/reviewReactionEngageMetrics';

function ReviewReactionStatsBlock({ title, metricsPrefix, metrics }) {
  const reactionMetrics = readReviewReactionEngageMetrics(metrics, metricsPrefix);

  return (
    <Box sx={{ mt: 2 }} data-testid={`${metricsPrefix}-review-reaction-stats`}>
      <Typography variant="subtitle2" component="h3" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2">
        {reactionMetrics.total.toLocaleString()} active reactions
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {reactionMetrics.reviewsWithReactions.toLocaleString()} reviews with
        reactions
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
          mt: 1,
        }}
      >
        {REVIEW_REACTION_EMOJI_ORDER.map((reactionType) => (
          <Typography key={reactionType.key} variant="body2">
            {reactionType.emoji} {reactionMetrics.counts[reactionType.key]}
          </Typography>
        ))}
      </Box>
      <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
        {reactionMetrics.fromUsers.toLocaleString()} from drinkers ·{' '}
        {reactionMetrics.fromBreweries.toLocaleString()} from breweries
      </Typography>
    </Box>
  );
}

ReviewReactionStatsBlock.propTypes = {
  title: PropTypes.string.isRequired,
  metricsPrefix: PropTypes.oneOf(['beer', 'hospitality']).isRequired,
  metrics: PropTypes.object,
};

export default ReviewReactionStatsBlock;
